import { Outlet } from "react-router-dom";

const RouteLayout = () => {
    return (
        <Outlet />
    );
};

export default RouteLayout;